import { supabase } from '../../../shared/lib/supabase';
import type { BillingOrgSettings, BillingOrgSettingsUpsertInput } from './billingTypes';

export class BillingOrgSettingsService {
  private table = 'billing_org_settings';

  async getAll(): Promise<BillingOrgSettings[]> {
    const { data, error } = await supabase
      .from(this.table)
      .select('*')
      .order('updated_at', { ascending: false });

    if (error) {
      console.error('Error fetching billing org settings list:', error);
      throw error;
    }

    return data || [];
  }

  async getByOrganisationId(organisationId: string): Promise<BillingOrgSettings | null> {
    const { data, error } = await supabase
      .from(this.table)
      .select('*')
      .eq('organisation_id', organisationId)
      .maybeSingle();

    if (error) {
      console.error('Error fetching billing org settings:', error);
      throw error;
    }

    return data;
  }

  async upsert(organisationId: string, input: BillingOrgSettingsUpsertInput): Promise<BillingOrgSettings> {
    const payload = {
      organisation_id: organisationId,
      currency: (input.currency || 'INR').toUpperCase(),
      default_tax_rate_percent: Number(input.default_tax_rate_percent || 0),
      prices_tax_inclusive: Boolean(input.prices_tax_inclusive),
      tax_label: input.tax_label ?? 'Tax',
      updated_at: new Date().toISOString(),
    };

    const { data, error } = await supabase
      .from(this.table)
      .upsert(payload, {
        onConflict: 'organisation_id',
        ignoreDuplicates: false,
      })
      .select()
      .single();

    if (error) {
      console.error('Error upserting billing org settings:', error);
      throw error;
    }

    return data;
  }
}

export const billingOrgSettingsService = new BillingOrgSettingsService();
